import { EntityToUpdate } from "abstract/entity-to-update"
import { apiCall } from "api-calls/api-call"
import { WinNotificationsResponse, WinNotificationType } from "../store/types"

export const getNotifications = async(
  filter: string,
  page: number,
  limit: number,
): Promise<{
  data: WinNotificationsResponse[];
  total: number;
}> => {
  const query: { page: number; limit: number; filter?: string } = {
    page,
    limit,
  }

  if (filter) query.filter = filter

  return apiCall({
    method: "GET",
    path: "notifications/desktop/templates",
    query: query,
  })
}

export const createNotification = async(data: EntityToUpdate<WinNotificationType>): Promise<{
  data: WinNotificationsResponse;
}> => {
  return apiCall({
    method: "POST",
    path: "notifications/desktop/templates",
    body: data,
  })
}

export const updateNotification = async(id: string, data: EntityToUpdate<WinNotificationType>): Promise<{
  data: WinNotificationsResponse;
}> => {
  return apiCall({
    method: "PUT",
    path: "notifications/desktop/templates" + `/${id}`,
    body: data,
  })
}

export const deleteNotification = async(id: string): Promise<{
  data: WinNotificationsResponse;
}> => {
  return apiCall({
    method: "DELETE",
    path: "notifications/desktop/templates" + `/${id}`,
  })
}

export const getNotification = async(id: string): Promise<{
  data: WinNotificationsResponse;
}> => {
  return apiCall({
    method: "GET",
    path: "notifications/desktop/templates" + `/${id}`,
  })
}

export const sendNotification = async(id: string): Promise<{
  data: WinNotificationsResponse;
}> => {
  return apiCall({
    method: "POST",
    path: "notifications/desktop/templates" + `/${id}/send`,
  })
}
